import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { getSystemData, progressBarData } from '../reducer';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { closeProgressBar, stoppedProgressBar } from '../actions';
import { copyTextToClipboard } from '../../../utils/utils';
import { getAwaitDocumentData } from '../../Application/reducer';
import Loader from '../../../components/base/Loader/Loader';

export default function ProcessProgressBar() {
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const {
    showProgressBar = false,
    stopProgressBar = false,
    progressBarPromiseId = null,
    progressBarTitle = '',
    progressText = '',
    progressLog = '',
    progressPercent = 0,
    progressCountSuccess = 0,
    progressCount = 0,
    progressCountError = 0,
  } = useSelector(progressBarData);

  const { loadingDocument } = useSelector(getAwaitDocumentData);
  const { loadingSignDocument } = useSelector(getSystemData);

  const hide = () => {
    rejectActionPromise({ promiseId: progressBarPromiseId })();
    dispatch(stopProgressBar ? closeProgressBar() : stoppedProgressBar());
  };

  if (!showProgressBar) {
    return null;
  }
  return (
    <Dialog open className="progress-popup" size="xl">
      <DialogTitle header={progressBarTitle} title={<Icons onClick={hide} customIcon icon="close" className="close" />} />
      <DialogContent>
        <div className="progress-block">
          <div className="progress-text">
            {formatMessage(
              { id: stopProgressBar ? `${progressText}.stopped` : progressText, defaultMessage: progressText },
              {
                progressCountSuccess,
                progressCount,
                progressCountError,
                stopProgressBar,
              },
            )}
            <div className="progress-loader">
              <Loader loading={loadingSignDocument || loadingDocument} />
            </div>
          </div>
          <div className="progress">
            <div className="progress-bar progress-bar-striped progress-bar-animated" style={{ width: `${Math.ceil(Number(progressPercent) || 0)}%` }} />
          </div>
          {progressLog && (
            <div className="progress-log mt-3">
              {/* html чист!!! Его генерирует само приложение! если ваш анализатор этого не понимает не используйте этот анализатор */}
              {/* eslint-disable-next-line react/no-danger */}{/* nosemgrep */}
              {progressLog.map((i, key) => <div key={key} className="progress-log-item" dangerouslySetInnerHTML={{ __html: i }} />)}
            </div>
          )}
        </div>
      </DialogContent>
      <DialogFooter className="modal-buttons">
        <Button variant="secondary" className="back" onClick={() => copyTextToClipboard(progressLog.join('\n'))}>Копировать лог в буфер обмена</Button>
        <Button className="back" onClick={hide}>{stopProgressBar ? 'Закрыть' : 'Остановить'}</Button>
      </DialogFooter>
    </Dialog>
  );
}
